import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../services/auth';

/**
 * Guards /admin and /super-admin routes.
 * Requires both a valid access token AND an admin/super-admin role.
 * Redirects non-admins to /auth/login (not to the admin portal).
 */
export const adminGuard: CanActivateFn = () => {
  const auth   = inject(Auth);
  const router = inject(Router);

  if (!auth.isLoggedIn() || !auth.hasAdminRole()) {
    router.navigate(['/auth/login']);
    return false;
  }

  return true;
};
